<template>
  <div v-loading="loading" class="content-container" style="height: auto">
    <search-comp @onSearch="onSearch" @onReset="onReset">
      <div class="das-form-container">
        <div class="das-form-group">
          <div class="das-form-row">
            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">Tháng</div>
                <div class="child-w-80">
                  <el-date-picker
                    v-model="searchParams.month"
                    type="month"
                    format="MM/yyyy"
                    value-format="yyyy-MM-01"
                    :clearable="false"
                    style="width: 100%"
                    placeholder="Chọn tháng"
                  />
                </div>
              </div>
            </div>
            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">Hạng phòng</div>
                <div class="child-w-80">
                  <!-- v-model="searchParams.roomNumber" -->
                  <select-with-search-table
                    style="width: 100%"
                    :rows="roomLevelRows"
                    :columns="roomLevelCols"
                    index-field="id"
                    :selected-index-field-value="searchParams.roomLevel"
                    :value="searchParams.roomLevel"
                    @selectionChanged="onSelectRowRoomLevel"
                  >
                    <template v-slot:value="{ selectedValue: selectedData }">
                      {{ selectedData?.name }}
                    </template>
                  </select-with-search-table>
                </div>
              </div>
            </div>
            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">Khách sạn</div>
                <div class="child-w-80">
                  <el-select
                    v-model="searchParams.hotelIdList"
                    collapse-tags
                    multiple
                  >
                    <el-option
                      v-for="(hotel, index) in hotelList"
                      :key="index"
                      :value="hotel.id"
                      :label="hotel.name"
                    />
                  </el-select>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </search-comp>

    <div class="content-box">
      <div class="section-box outline">
        <div class="das-form-container mt-10">
          <div class="das-form-group">
            <div class="das-form-row">
              <div class="das-form-col col-12">
                <div class="chartwithbutton">
                  <vchart
                    :key="chartKey"
                    style="height: 700px"
                    class="chart"
                    :option="optionHistogramChart"
                    autoresize
                    @click="handleClick"
                  />
                  <div class="button-containers-title">
                    <button class="btn small primary outline download-button">
                      <i class="el-icon-download"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- </div> -->
      </div>
    </div>

    <el-dialog
      title="Chú thích"
      :visible.sync="dialogFormVisible"
      :close-on-click-modal="false"
      width="500px"
    >
      <div class="das-form-container">
        <div class="das-form-group">
          <ul class="annotate-container">
            <li>Hạng phòng: hiển thị hạng phòng (Cấu hình)</li>
            <li>
              Số phòng bị chiếm: Số phòng bị chiếm của hạng phòng trong khoảng
              thời gian tìm kiếm
            </li>
            <li>Tổng số phòng: tổng số phòng vật lý - OOO</li>
            <li>Tỉ lệ: số phòng bị chiếm/tổng số phòng *100. đơn vị %</li>
            <li>Doanh thu: Tổng doanh thu phòng của hạng phòng</li>
          </ul>
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <div class="button-containers">
          <button class="btn primary small" @click="dialogFormVisible = false">
            {{ $t('button.cancel') }}
          </button>
        </div>
      </span>
    </el-dialog>
  </div>
</template>

<script>
// import CalendarRange from '@/components/CalendarSelect/CalendarRange.vue'
import SelectWithSearchTable from '@/components/inputs/SelectWithSearchTable.vue'

import { getAllHotel } from '@/api/hotel'
import { getListRoomLevelApi } from '@/api/Room/roomLevel'
import { getFillRateByMonthApi } from '@/api/report_service/report_b'
import { BarChart } from 'echarts/charts'
import { use } from 'echarts/core'

use([BarChart])
// import InfoBtn from './components/InfoBtn.vue'

const getOptionHistogramChartDefault = () => ({
  title: {
    text: 'Tỷ lệ lấp đầy theo tháng'
    // left: 'center'
  },
  tooltip: {
    trigger: 'axis',
    axisPointer: { type: 'shadow' },
    extraCssText: 'max-height: 300px; overflow-y: auto;'
  },
  grid: {
    left: '3%',
    right: '4%',
    top: 70,
    bottom: 30,
    containLabel: true
  },
  yAxis: {
    type: 'value',
    min: 0,
    max: 100,
    axisLabel: { formatter: '{value}%' }
  },
  xAxis: {
    type: 'category',
    data: []
  },
  series: []
})

export default {
  components: {
    // CalendarRange,
    // InfoBtn,
    SelectWithSearchTable
  },
  data() {
    return {
      loading: 1,
      chartKey: 1,
      dialogFormVisible: false,
      hotelList: [],
      roomLevelRows: [],
      roomLevelCols: [
        {
          headerName: 'Mã',
          field: 'code',
          tooltipField: 'code',
          width: 150
        },
        {
          headerName: 'Tên',
          field: 'name',
          tooltipField: 'name',
          minWidth: 150
        }
      ],
      searchParams: {
        month: this.$moment().startOf('month').format('YYYY-MM-DD'),
        roomLevel: null,
        hotelIdList: []
      },
      searchParamsDefault: {
        month: this.$moment().startOf('month').format('YYYY-MM-DD'),
        roomLevel: null,
        hotelIdList: []
      },
      optionHistogramChart: getOptionHistogramChartDefault(),

      columns: [
        // {
        //   headerName: '',
        //   field: 'index',
        //   minWidth: 60,
        //   maxWidth: 60,
        //   headerCheckboxSelection: true,
        //   headerCheckboxSelectionFilteredOnly: true,
        //   checkboxSelection: true,
        //   resizable: false
        //   // cellStyle: {'padding-left': '12px'}
        // },
        {
          headerName: this.$t('grid.column.roomLevel'),
          field: 'hotel_nm',
          // cellClass: "grid-cell-centered",
          sortable: false
        },
        {
          headerName: this.$t('grid.column.occupiedRoom'),
          field: 'building_no',
          // cellClass: "grid-cell-centered",
          // width: 100,
          sortable: false
        },
        {
          headerName: this.$t('grid.column.allRoom'),
          field: 'name',
          // cellRenderer: 'CellRenderTextInput',
          sortable: false
          // cellClass: "grid-cell-centered",
        },
        {
          headerName: this.$t('grid.column.percent'),
          field: 'name',
          // cellRenderer: 'CellRenderTextInput',
          sortable: false
          // cellClass: "grid-cell-centered",
        },
        {
          headerName: this.$t('grid.column.revenue'),
          field: 'name',
          // cellRenderer: 'CellRenderTextInput',
          sortable: false
          // cellClass: "grid-cell-centered",
        }
      ],
      rows: []
    }
  },
  // created() {

  // },
  async mounted() {
    await this.getListHotel()
    if (this.hotelList.length > 0) {
      // TODO
      // this.searchParams.hotelIdList = [this.hotelList[0].id]
    }
    this.getRoomLevelOptions()
    await this.onSearch()
  },
  methods: {
    handleCommand(cmmd) {
      this.$message('click on item ' + cmmd)
    },
    async getListHotel() {
      const data = await getAllHotel()
      this.hotelList = data.data
    },
    async getRoomLevelOptions() {
      const data = await getListRoomLevelApi()
      this.roomLevelRows = data?.data || []
      // await getRoom()
    },
    onSelectRowRoomLevel(val) {
      this.searchParams.roomLevel = val?.id || null
    },
    async onSearch() {
      this.loading = true
      this.optionHistogramChart = getOptionHistogramChartDefault()

      await getFillRateByMonthApi(this.searchParams)
        .then(res => {
          const days = (res.data || []).map(day => {
            const rooms = (day.infoList || []).filter(room =>
              room.roomLevel !== 'ALL' && Number(room.numOfRoom) > 0
            )
            const occupied = rooms.reduce((sum, room) => sum + Number(room.occupiedRoom || 0), 0)
            const total = rooms.reduce((sum, room) => sum + Number(room.numOfRoom), 0)
            return {
              date: day.date,
              rooms,
              occupied,
              total,
              ratio: total ? Number((occupied / total * 100).toFixed(2)) : 0
            }
          })
          const occupiedMonth = days.reduce((sum, day) => sum + day.occupied, 0)
          const totalMonth = days.reduce((sum, day) => sum + day.total, 0)
          const ratioMonth = totalMonth ? (occupiedMonth / totalMonth * 100).toFixed(2) : '0.00'

          this.optionHistogramChart.title.text = `Tỷ lệ lấp đầy theo tháng: ${ratioMonth}%`
          this.optionHistogramChart.xAxis.data = days.map(day => day.date)
          this.optionHistogramChart.series = [{
            name: 'Tỷ lệ chung',
            type: 'bar',
            barMaxWidth: 40,
            data: days.map(day => day.ratio)
          }]
          this.optionHistogramChart.tooltip.formatter = params => {
            const day = days[params[0].dataIndex]
            if (!day) return ''
            const escapeHtml = value => String(value).replace(/[&<>"']/g, char => ({
              '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'
            })[char])
            const roomRows = day.rooms.map(room => {
              const roomRatio = (Number(room.occupiedRoom || 0) / Number(room.numOfRoom) * 100).toFixed(2)
              return `<div>${escapeHtml(room.roomLevel)}: ${roomRatio}% (${room.occupiedRoom}/${room.numOfRoom})</div>`
            }).join('')
            return `<strong>${escapeHtml(day.date)}</strong><br>` +
              `<div>Tỷ lệ chung: ${day.ratio.toFixed(2)}%</div>` +
              `<div>Phòng có khách/tổng phòng: ${day.occupied}/${day.total}</div>` + roomRows
          }
        })
        .catch(error => {
          this.$message({
            type: 'error',
            message: this.$t('errorMsg.' + error.response.data.message)
          })
        })
        .finally(() => {
          this.chartKey = this.chartKey + 1
          this.loading = false
        })
    },
    async onReset() {
      this.searchParams = {
        ...this.searchParamsDefault,
        hotelIdList: [...this.searchParamsDefault.hotelIdList]
      }
      await this.onSearch()
    },
    handleClick(e) {
      this.columnsClick = e
      this.$router.push({
        path: '/report/director_report/room_report/fill_rate_report'
      })
    },
    async fnStoreRouteData({ to, from }) {
      const params = {
        ...to.params,
        date_from: this.columnsClick?.name,
        date_to: this.columnsClick?.name
      }
      const routeData = {
        ...to,
        from,
        params
      }
      this.$store.dispatch('app/setRouteData', routeData)
    }
  },
  async beforeRouteLeave(to, from, next) {
    if (to.path === '/report/director_report/room_report/fill_rate_report') {
      await this.fnStoreRouteData({ to, from })
    }
    next()
  }
}
</script>

<style lang="scss"></style>
